import { Market } from 'clickNgo/configs/geo'
import { Roles } from 'clickNgo/configs/roles'
import { IUser } from 'core-components/sitebuilder/models/IUser'

export const checkReadOnlyAccess = (user: IUser) => {
  const isChinaReadOnly =
    user.geoMarket === Market.GREATER_CHINA &&
    user.roleIds.every((role) => role === Roles.READ_ONLY_ROLE || role === Roles.PBM)

  const isReadOnly = isChinaReadOnly || user.roleIds.some((role) => role === Roles.READ_ONLY_ROLE)

  return isReadOnly
}
